<mat-card>{{'addUser' | translate}}</mat-card>

<mat-grid-list cols="5" rowHeight="70px">
  <mat-grid-tile colspan="1"></mat-grid-tile>
  <mat-grid-tile colspan="2">
    <mat-form-field appearance="standard">
      <mat-label>{{'role' | translate}}</mat-label>
      <mat-select [(value)]="selectedRole" (selectionChange)="onRoleSelected()">
        <mat-option *ngFor="let role of roles" [value]="role.id">
          {{role.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </mat-grid-tile>
</mat-grid-list>

<mat-grid-list cols="5" rowHeight="70px" *ngIf="selectedRole == 3">
  <mat-grid-tile colspan="1"></mat-grid-tile>
  <mat-grid-tile colspan="2">
    <mat-form-field appearance="standard">
      <mat-label>اختر المندوب</mat-label>
      <mat-select [(value)]="selectedMandoob" (selectionChange)="onSelectMandoob()">
        <mat-option *ngFor="let item of mandoobs" [value]="item.id">
          {{item.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </mat-grid-tile>
</mat-grid-list>

<mat-grid-list cols="5" rowHeight="70px">
  <mat-grid-tile colspan="1"></mat-grid-tile>
  <mat-grid-tile colspan="2">
    <mat-form-field appearance="standard">
      <mat-label>{{'fullName' | translate}}</mat-label>
      <input matInput [(ngModel)]="user.fullName" required #fullName="ngModel" [disabled]="selectedRole == 3">
      <mat-error *ngIf="fullName.invalid">{{'requiredField' | translate}}</mat-error>
    </mat-form-field>
  </mat-grid-tile>
</mat-grid-list>

<mat-grid-list cols="5" rowHeight="70px">
  <mat-grid-tile colspan="1"></mat-grid-tile>
  <mat-grid-tile colspan="2">
    <mat-form-field appearance="standard">
      <mat-label>{{'userName' | translate}}</mat-label>
      <input matInput [(ngModel)]="user.userName" required #userName="ngModel">
      <mat-error *ngIf="userName.invalid">{{'requiredField' | translate}}</mat-error>
    </mat-form-field>
  </mat-grid-tile>
</mat-grid-list>

<mat-grid-list cols="5" rowHeight="70px">
  <mat-grid-tile colspan="1"></mat-grid-tile>
  <mat-grid-tile colspan="2">
    <mat-form-field appearance="standard">
      <mat-label>{{'phone' | translate}}</mat-label>
      <input matInput [(ngModel)]="user.phoneNumber" required #phone="ngModel">
      <mat-error *ngIf="phone.invalid">{{'requiredField' | translate}}</mat-error>
    </mat-form-field>
  </mat-grid-tile>
</mat-grid-list>

<mat-grid-list cols="5" rowHeight="70px">
  <mat-grid-tile colspan="1"></mat-grid-tile>
  <mat-grid-tile colspan="2">
    <mat-form-field appearance="standard">
      <mat-label>{{'email' | translate}}</mat-label>
      <input matInput [(ngModel)]="user.email" required #email="ngModel">
      <mat-error *ngIf="email.invalid">{{'requiredField' | translate}}</mat-error>
    </mat-form-field>
  </mat-grid-tile>
</mat-grid-list>

<mat-grid-list cols="5" rowHeight="70px">
  <mat-grid-tile colspan="1"></mat-grid-tile>
  <mat-grid-tile colspan="2">
    <mat-form-field appearance="standard">
      <mat-label>{{'password' | translate}}</mat-label>
      <input matInput type="password" name="pass" autocomplete="off" [(ngModel)]="user.password" required
        #password="ngModel">
      <mat-error *ngIf="password.invalid">{{'requiredField' | translate}}</mat-error>
    </mat-form-field>
  </mat-grid-tile>
</mat-grid-list>

<mat-grid-list cols="5" rowHeight="70px">
  <mat-grid-tile colspan="1"></mat-grid-tile>
  <mat-grid-tile colspan="2">
    <mat-form-field appearance="standard">
      <mat-label>{{'confirmPassword' | translate}}</mat-label>
      <input matInput type="password" name="cpass" autocomplete="off" [(ngModel)]="user.confirmPassword" required
        #confirmPass="ngModel">
      <mat-error *ngIf="confirmPass.invalid">{{'requiredField' | translate}}</mat-error>
    </mat-form-field>
  </mat-grid-tile>
</mat-grid-list>



<mat-grid-list cols="5" rowHeight="70px" *ngIf="selectedRole == 3">
  <mat-grid-tile colspan="1"></mat-grid-tile>
  <mat-grid-tile colspan="2">
    <mat-form-field appearance="standard">
      <mat-label>{{'balance' | translate}}</mat-label>
      <input matInput type="number" name="bal" autocomplete="off" [(ngModel)]="user.ballance">
    </mat-form-field>
  </mat-grid-tile>
</mat-grid-list>



<mat-grid-list cols="4" rowHeight="100px">
  <mat-grid-tile></mat-grid-tile>
  <mat-grid-tile>
    <!-- <button mat-raised-button (click)="back()">
            <mat-icon>keyboard_backspace</mat-icon>
            Back</button>
            &nbsp; -->
    <button mat-raised-button color="primary" (click)="submit()"
      [disabled]="fullName.invalid || userName.invalid || password.invalid || confirmPass.invalid">
      <mat-icon>done</mat-icon>
      {{'submit' | translate}}
    </button>
  </mat-grid-tile>
</mat-grid-list>

<app-userslist [addNew]="addNew"></app-userslist>

<app-matspinner [overlay]="spinnerOverlay"></app-matspinner>